import { makeStyles } from '@material-ui/core';

const panelWidth = 380;

export const useStyles = makeStyles(theme => ({
  root: {
    margin: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  button: {
    margin: theme.spacing(0.5, 0),
    border: '1px solid',
    borderRadius: theme.spacing(1),
    color: theme.palette.primary.main,
    minWidth: 90
  },
  panel: {
    width: panelWidth,
    padding: '0px !important'
  }
}));
